import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import FrontFooter from "../../shared/FrontFooter";
import { BannerProvider } from "../../providers/BannerProviders";
import { setTitle } from "../../helpers/MetaTag";

const FrontLayout = ({ metaTitle }) => {
  setTitle(`${metaTitle}`);
  const location = useLocation()
  console.log(location?.pathname)
  useEffect(() => {
    
  }, []);
  return (
    <BannerProvider>
      <FrontHeader />
      <Outlet />
      <FrontFooter />
    </BannerProvider>
  );
};

export default FrontLayout;
